import { TOGGLE_SIDEMENU, TOGGLE_NAV } from "../constants/action-types";
import { experience } from "../constants/experience";

const initialState = {
  sidemenuOn: false,
  navToggleOn: "abc",
  experience: experience
};
const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SIDEMENU:
      return Object.assign({}, state, { sidemenuOn: !state.sidemenuOn });
    case TOGGLE_NAV:
      console.log("in reducer ", state);
      return Object.assign({}, state, { navToggleOn: state.navToggleOn });
    default:
      return state;
  }
};
export default rootReducer;
